import React from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";
import {makeStyles} from "@material-ui/core";
import ScrollableAnchor from "react-scrollable-anchor";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {answerState, menuCheckSelector, selectedMenuItemState, surveyDataState} from "../../state/globalState";
/**
 * 설문 문항 컴포넌트
 */
const Survey0 = (props) => {
    const surveyData = useRecoilValue(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const userName = answer.userNm;
    const [isError, setIsError] = React.useState(false);
    const [errorMsg, setErrorMsg] = React.useState('');
    let parentCompRef = props.compRef;

    const handleInputAnswer = (e, column) => {
        const { value } = e.target;

        // 사용자이름 정규식 표현
        const namePattern = /^[가-힣a-zA-Z\s]{2,20}$/;
        let flag = false;

        const newState = {
            ...answer,
            [column]: value
        }
        setAnswer({
            ...answer,
            [column]: value
        });

        setSelectedMenuItem('SURVEY_5');
        setMenuCheck(value !== '');

        flag = namePattern.test(value);

        if (value === '' || flag) {
            setIsError(false);
            setErrorMsg('');
            // dispatch(setError('0'));
        } else {
            setIsError(true);
            // dispatch(setError('0'));
            setErrorMsg('한글/영문 두 글자 이상 입력하세요.');
        }
    };

    const addRefs = (e) => {
        parentCompRef[5] = e;
    };

    return (
        <>
            <ScrollableAnchor id={"5"}>
                <div>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={surveyData[5].title}
                        sentences={surveyData[5].questions}
                        step={5}
                    />
                    <div className="textFieldContainer">
                        <TextField
                            key={'userName'}
                            label="여기에 답변을 입력하십시오."
                            placeholder=""
                            margin="none"
                            error={isError}
                            helperText={errorMsg}
                            value={userName}
                            onChange={(e) => handleInputAnswer(e, 'userNm')}
                            inputRef={addRefs}
                        />
                    </div>
                </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey0;
